import React, { memo, useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import get from "lodash/get";
import find from "lodash/find";
import {
  clearData,
  initiatePortIn,
  reinitiatePortIn,
  reschedulePortIn,
  cancelPortIn,
  changeFormField,
  uploadScreenshot
} from "ducks/actions";
import {
  makeSelectTelcoList,
  makeSelectIsFetchingData,
  makeSelectPageValidations,
  makeSelectWorkflow,
  makeSelectPortInFormPayload,
  makeSelectPortInFormInitialValues,
  makeSelectScreenshot,
  makeSelectPortInForm
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import { forms } from "utils/constants";
import { handleOnLoadAction } from "utils/helpers";
import Spinner, { styles } from "components/Spinner";
import validate from "validations";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import { isActivationSuccess } from "utils/localStorage";

const ManagePortInHOC = Component =>
  function Comp(props) {
    const {
      isFetchingReinitiatePortin,
      isFetchingInitiatePortin,
      initialValues,
      telcoList,
      changePortInFormField,

      clearScreenshot
    } = props;
    const [initialDonorTelco, setInitialDonorTelco] = useState(null);

    useEffect(
      () => {
        clearScreenshot();
        !isActivationSuccess() && handleOnLoadAction(props);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    useEffect(() => {
      const initialExistingDonorTelco = get(initialValues, "donorTelco");
      if (isNull(initialDonorTelco)) {
        setInitialDonorTelco(initialExistingDonorTelco);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValues]);

    //update form field base on initial donor telco
    useEffect(() => {
      !isNull(initialDonorTelco) &&
        changePortInFormField(
          "donorTelco",
          find(telcoList, { value: initialDonorTelco })
        );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialDonorTelco]);

    return isFetchingInitiatePortin || isFetchingReinitiatePortin ? (
      <Spinner size={200} sx={styles.fullPage} />
    ) : (
      <Component {...props} />
    );
  };

const mapStateToProps = (_, props) =>
  createStructuredSelector({
    telcoList: makeSelectTelcoList(),
    formValidations: makeSelectPageValidations(forms.PORT_IN_FORM),
    workflow: makeSelectWorkflow(),
    payload: makeSelectPortInFormPayload(),
    isFetchingInitiatePortin: makeSelectIsFetchingData("initiatePortIn"),
    isFetchingReinitiatePortin: makeSelectIsFetchingData("reinitiatePortIn"),
    screenshot: makeSelectScreenshot(),
    reinitiatePortInFormValues: makeSelectPortInForm(),
    initialValues: state => {
      return makeSelectPortInFormInitialValues()(state);
    }
  });

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});

export function mapDispatchToProps(dispatch) {
  return {
    clearScreenshot: () => {
      dispatch(clearData("screenshot"));
    },

    initiatePortIn: (navigate, payload) => {
      dispatch(
        initiatePortIn(get(payload, "initiate"), (_, error) => {
          if (isEmpty(error)) {
            console.log("initiatePortIn success.");
            navigate();
          }
        })
      );
    },
    reinitiatePortIn: (navigate, payload) => {
      dispatch(clearData("screenshot"));
      dispatch(
        reinitiatePortIn(get(payload, "reinitiate"), (_, error) => {
          if (isEmpty(error)) {
            console.log("reinitiatePortIn success.");
            navigate();
          }
        })
      );
    },
    reschedulePortIn: (navigate, payload) => {
      dispatch(
        reschedulePortIn(payload, (_, error) => {
          if (isEmpty(error)) {
            console.log("reschedulePortIn success.");
            navigate();
          }
        })
      );
    },
    cancelPortIn: (navigate, payload) => {
      dispatch(
        cancelPortIn(payload, (_, error) => {
          if (isEmpty(error)) {
            console.log("cancelPortIn success.");
            navigate();
          }
        })
      );
    },
    changePortInFormField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PORT_IN_FORM,
          field: field,
          value: value
        })
      );
    },
    uploadScreenshot: payload => dispatch(uploadScreenshot(payload))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.PORT_IN_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(ManagePortInHOC(SmartRender));
